/*
 *  Product Description
 *    Create accordion for the product description metafield data.
 *
 *  Version:
 *    1.0.0 - 2019/08/05
 */
import { register, ShopifySection } from './../ShopifySection';
import { Accordion } from './../../objects/accordion/Accordion';
import { getVariantDimensions } from './../../tools/VariantDimensions';
import { ON_VARIANT_CHANGE } from './../../objects/variant/VariantSelector';

export const CONTAINER_SELECTOR = '[data-product-description]';
export const ACCORDION_SELECTOR = '[data-accordion]';
export const SELECTOR_DIMENSIONS = '[data-product-dimensions]';

export class ProductDescription extends ShopifySection {
  constructor(container) {
    super(container);

    //Accordion (If it exists)
    let accordionElement = container.find(ACCORDION_SELECTOR);

    if(accordionElement && accordionElement.length) {
      this.accordion = new Accordion(accordionElement);
    }

    $(document).on(ON_VARIANT_CHANGE, (e,v) => this.updateDimensions(v));
  }

  updateDimensions(variant) {
    let el = this.container.find(SELECTOR_DIMENSIONS);
    if(!el || !el.length) return;
    el.html(getVariantDimensions(variant));
  }
}

register(CONTAINER_SELECTOR, ProductDescription);
